import moment from "moment";
import { cloneDeep } from "lodash";

import { DateRangePicker } from "../../react/utils/dateRangePicker/DateRangePicker";

import template from "./pTeamLeaderView.html";

export function pTeamLeaderViewDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pTeamLeaderViewController,
    controllerAs: 'pTeamLeaderView',
    bindToController: true
  };

  return directive;
}

const manuallyProjectsFlag = "ProjectsSetManually";
const erpProjectsFlag = "ProjectsFromErpSystem";
const manuallyProjectsSource = "AddedManually";

class pTeamLeaderViewController {
  constructor($filter, $translate, Auth, Notes, DownloadFile, Stats, Work, bModal, OvertimeApplications, $scope, $interval, $location, $q, ConnectionQuality) {
    'ngInject';

    this.$filter = $filter;
    this.$translate = $translate;
    this.Notes = Notes;
    this.$scope = $scope;
    this.Auth = Auth;
    this.DownloadFile = DownloadFile;
    this.Stats = Stats;
    this.Work = Work;
    this.ConnectionQuality = ConnectionQuality;
    this.bModal = bModal;
    this.$interval = $interval;
    this.$location = $location;
    this.$q = $q;
    this.OvertimeApplications = OvertimeApplications;

    this.isInvalidDateStart = false;
    this.isInvalidDateEnd = false;
    this.allColumnsSelected = true;

    this.state = "loading";

    this.sortStates = {};
    this.sortStatesProject = {};
    this.sortStatesProcessGroup = {};
    this.sortStatesProcess = {};

    this.dateToday = moment().format("YYYY-MM-DD");
    this.dateStart = moment(this.dateToday);
    this.dateEnd = moment(this.dateToday);
    this.isDateTodayOrLater = true;
    this.disabledEdition = false;
    this.workspace = {};
    this.summary = {};
    this.billingTypes = [];
    this.flagsLoading = false;
    this.moment = moment;

    this.search = '';
    this.searchOpen = false;

    this.viewType = this.$location.path().includes('/management') ? 'management' : 'team';
    this.isManagementViewType = this.viewType === 'management';
    this.preferredColumns = this.isManagementViewType ? 'mvWorklogSelectedColumns' : 'tlvWorklogSelectedColumns';
    this.preferredUsers = this.isManagementViewType ? 'mvWorklogSelectedUsers' : 'tlvWorklogSelectedUsers';
    //TO-DO Check why it doesn't work or create some init() function for requests
    this.$scope.$watch(() => this.summary, () => this.addOutputs());
    this.$scope.$watch(() => this.workspace, () => this.addOutputs());

    this.outputTypeFeatureFlag = false;

    if (localStorage.getItem('roedl-dark-background')) {
      document.querySelector('body').classList.add('darkerBackground');
    }

    this.checkTimeOverlapTimer;

    this.d365StatusFilters = [
      {
        value: "noD365Status",
        translation: "NO_D365_STATUS",
        selected: true
      },
      {
        value: "D365Sent",
        translation: "SENT",
        selected: true,
        color: "green"
      },
      {
        value: "D365Processed",
        translation: "PROCESSED",
        selected: true,
        color: "green"
      },
      {
        value: "D365ProcessedToKCP",
        translation: "PROCESSED_TO_KCP",
        selected: true,
        color: "green"
      },
      {
        value: "D365Error",
        translation: "ERROR",
        selected: true,
        color: "red"
      },
      {
        value: "D365ProcessMatchingNotFound",
        translation: "PROCESS_ERROR",
        selected: true,
        color: "red"
      },
      {
        value: "D365ProjectNotFound",
        translation: "PROJECT_ERROR",
        selected: true,
        color: "red"
      },
      {
        value: "SendingError",
        translation: "SENDING_ERROR",
        selected: true,
        color: "red"
      },
      {
        value: "D365Deleted",
        translation: "DELETED",
        selected: true,
        color: "red"
      }
    ];
    this.allD365StatusesSelected = true;

    this.headersToSelect = [
      { id: "clientName", name: "STATS.CLIENT_NAME", class: "table-info" },
      { id: "projectName", name: "WORK_DATA.PROJECT", class: "table-info" },
      { name: "PROCESS_GROUP", class: "table-info table-pg" },
      { name: "PROCESS", class: "table-info table-process" },
      { id: "startDate", name: "WORK_DATA.START_DATE", class: "table-date" },
      { id: "startTime", name: "WORK_DATA.START_TIME", class: "table-time" },
      { id: "endTime", name: "WORK_DATA.END_TIME", class: "table-time" },
      { name: "WORK_DATA.DURATION", class: "table-time" },
      { id: "va", name: "WORK_DATA.VA", class: "table-short" },
      { id: "volume", name: "WORK_DATA.VOLUME", class: "table-number" },
      { id: "addedManually", name: "WORK_DATA.ADDED_MANUALLY", class: "table-short" },
      { id: "comment", name: "WORK_DATA.COMMENT", class: "table-comment" },
      { id: "invoiceDetails", name: "WORK_DATA.INVOICE_DETAILS", class: "table-comment" },
      { name: null, class: "table-actions" },
    ];

    this.worklogsTableUnsortedHeaders = [
      {
        id: "startDate",
        name: this.$translate.instant("WORK_DATA.START_DATE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.DATE"),
        class: "table-date",
        visible: true,
        selectable: true
      },
      {
        id: "startTime",
        name: this.$translate.instant("WORK_DATA.START_TIME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.START_TIME"),
        class: "table-time",
        visible: true,
        selectable: true
      },
      {
        id: "endTime",
        name: this.$translate.instant("WORK_DATA.END_TIME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.END_TIME"),
        class: "table-time",
        visible: true,
        selectable: true
      },
      {
        id: "duration",
        name: this.$translate.instant("WORK_DATA.DURATION"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.DURATION"),
        class: "table-time",
        visible: false,
        selectable: false
      },
      {
        id: "va",
        name: this.$translate.instant("WORK_DATA.VA"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.VALUE_ADDED"),
        class: "table-short",
        visible: true,
        selectable: true
      },
      {
        id: "volume",
        name: this.$translate.instant("WORK_DATA.VOLUME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.VOL"),
        class: "table-number",
        visible: true,
        selectable: true
      },
      {
        id: "addedManually",
        name: this.$translate.instant("WORK_DATA.ADDED_MANUALLY"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.ADDED_MAN"),
        class: "table-short",
        visible: true,
        selectable: true
      },
      {
        id: "comment",
        name: this.$translate.instant("WORK_DATA.COMMENT"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.COMMENT"),
        class: "table-comment",
        visible: true,
        selectable: true
      },
      {
        id: "invoiceDetails",
        name: this.$translate.instant("WORK_DATA.INVOICE_DETAILS"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.WORKLOGS.INVOICE_DETAILS"),
        class: "table-comment",
        visible: true,
        selectable: true
      }
    ];

    this.preferencesDictionary = {
      managementLevel: "Management",
      teamLeaderLevel: "TeamLeader",
      deputyTeamLeaderLevel: "DeputyTeamLeader",
      employeeLevel: "Employee"
    };

    this.multiSelectSettings = {
      displayProp: 'name',
      showCheckAll: false,
      showUncheckAll: false,
      smartButtonMaxItems: 2,
      checkBoxes: true,
      scrollableHeight: 'auto',
      scrollable: true,
      enableSearch: false,
    };

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        if (this.isManagementViewType)
          this.$q.all([this.Stats.getSubordinateTeams(), this.Work.getViewLevelSettings()]).then(
            (success) => {
              this.subTeams = success[0].data
                .filter(sub =>
                  this.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' ? sub.id !== '49a6dcff-c4e6-443e-9627-597070a68c8e' : true
                ).sort((a, b) => a.name.localeCompare(b.name));
              this.noViewLevelSettings = success[1].status === 204;

              if (this.noViewLevelSettings) {
                this.managementMode = true;
                this.managementLevel = true;
                this.state = "loaded";
              } else {
                this.setPreferencesInfo(success[1].data);
                this.init();
              }
            }, (res) => {
              this.state = "error";
              this.error = res;
              this.Notes.postNote({
                type: "error",
                error: res
              });
            }
          );
        else
          this.init();
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  setPreferencesInfo(data) {
    Object.entries(this.preferencesDictionary).forEach(([key, value]) => {
      if (data.viewLevels.includes(value))
        this[key] = true;
    });
    this.employeeLevelTeam = data.teamId;
  }

  getWorkspaceInfo() {
    this.Work.getWorkspace().then(
      (workspaceData) => {
        workspaceData.data.clients.map(client => {
          if (client.additionalInfo) {
            client.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.name}`;
          }
        });
        this.workspace = workspaceData.data;
        this.problems = {};
        this.workspace.problems.map((problem) => {
          this.problems[problem.id] = problem.name;
        });
        this.clients = workspaceData.data.clients || [];
        this.clientsLoaded = true;
      },
      (error) => {
        this.clientsLoaded = true;
        this.state = "error";
        this.error = error;
      }
    );

    if (this.hasProjectsFlag) {
      this.flagsLoading = true;

      const flagsRequest = this.isManagementViewType
        ? this.Work.getClientsWithFlagsHistoryForManager()
        : this.Work.getClientsWithFlagsHistory();

      flagsRequest.then(
        (response) => {
          this.projectFlagHistory = response.data.projectFlagHistory || [];
          this.currentFlag = this.projectFlagHistory.find(f => f.start && !f.end);
          this.flagsLoading = false;
        },
        (error) => {
          this.flagsLoading = false;
          this.error = error;
        }
      );
    }
  }

  async init() {
    if (!this.user.preferences || !this.user.preferences.featureFlags) {
      this.Auth.setFeatureFlagsToLocaleStorage(this.user).then(newUserInfo => {
        this.user = newUserInfo;
        this.invoiceDetailsFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "InvoiceDetails");
        this.hasProjectsFlag = !!this.user.preferences.featureFlags.find(f => f == manuallyProjectsFlag) || !!this.user.preferences.featureFlags.find(f => f == erpProjectsFlag);
        this.outputTypeFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "OutputType");
        this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(ff => ff === "OvertimeApplications");
        this.D365IntegrationFlag = this.user.preferences.featureFlags.some(ff => ff === "D365Integration");
      });
    } else {
      this.invoiceDetailsFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "InvoiceDetails");
      this.hasProjectsFlag = !!this.user.preferences.featureFlags.find(f => f == manuallyProjectsFlag) || !!this.user.preferences.featureFlags.find(f => f == erpProjectsFlag);
      this.outputTypeFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "OutputType");
      this.acceptanceHierarchyFlag = this.user.preferences.featureFlags.some(ff => ff === "AcceptanceHierarchy");
      this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(ff => ff === "OvertimeApplications");
      this.D365IntegrationFlag = this.user.preferences.featureFlags.some(ff => ff === "D365Integration");
    }

    // filter out project header (floatingHeaders) if no projects flag
    const filteredHeaders = this.headersToSelect && this.headersToSelect.filter(h => h.id !== "projectName");
    this.headers = this.hasProjectsFlag && this.headersToSelect || filteredHeaders;

    let isDateInSessionStorage = this.isManagementViewType
      ? sessionStorage.getItem("roedl-mv-date-start")
      : sessionStorage.getItem("roedl-tl-date-start");
    let areSelectedColumnsInPreferences = this.user.preferences[this.preferredColumns] ? true : false;

    this.inactivityPeriods = this.user.preferences.tlvWorklogInactivityPeriods;
    this.clientsLoaded = false;

    await this.Work.getCountryBillingTypes()
      .then(({ data: { billingTypes }}) =>
        this.billingTypes = Object.entries(billingTypes).reduce((accu, curr) => {
          accu.push({id: curr[0], name: curr[1]});
          return accu;
        }, [])
      )
      .catch(error => {
        this.state = "error";
        this.error = error;
      });

    this.getWorkspaceInfo();

    if (isDateInSessionStorage) {
      if (this.isManagementViewType) {
        this.dateStartChoice = sessionStorage.getItem("roedl-mv-date-start");
        this.dateEndChoice = sessionStorage.getItem("roedl-mv-date-end");
      } else {
        this.dateStartChoice = sessionStorage.getItem("roedl-tl-date-start");
        this.dateEndChoice = sessionStorage.getItem("roedl-tl-date-end");
      }
    }

    if (areSelectedColumnsInPreferences) {
      this.worklogsTableColumns = this.user.preferences[this.preferredColumns]
        .filter(col => col.selectable) || [];
      this.allColumnsSelected = this.user.preferences[this.preferredColumns].every( el => el.visible);
      this.worklogsTableColumns.forEach(column => { this.checkColumnInvisibility(column.id); });
      this.updateHeadersVisibility();
    } else {
      this.worklogsTableColumns = this.worklogsTableUnsortedHeaders.filter(col => col.selectable) || [];
      this.worklogsTableColumns.forEach(column => { this.checkColumnInvisibility(column.id); });
      this.Stats.changeTeamLeaderGlobalPreferences(this.preferredColumns, this.worklogsTableColumns)
      .then(()=>{
        this.user.preferences[this.preferredColumns] = this.worklogsTableColumns;
      }).catch(
        res => this.Notes.postNote({
          type: "error",
          error: res
        })
      );
    }

    const worklogsRequest = this.isManagementViewType
      ? this.Stats.getWorklogsForManager(this.dateStartChoice, this.dateEndChoice)
      : this.Stats.getWorklogs(this.dateStartChoice, this.dateEndChoice);

    worklogsRequest.then(
      (success) => {
        // get worklogs for the first time - date is loading from be (or session storage) - it must be set in datepicker
        if (!isDateInSessionStorage) {
          this.dateStartChoice = moment(success.data.from).format("YYYY-MM-DD");
          this.dateEndChoice = moment(success.data.to).format("YYYY-MM-DD");

          if (this.isManagementViewType) {
            sessionStorage.setItem("roedl-mv-date-start", this.dateStartChoice);
            sessionStorage.setItem("roedl-mv-date-end", this.dateEndChoice);
          } else {
            sessionStorage.setItem("roedl-tl-date-start", this.dateStartChoice);
            sessionStorage.setItem("roedl-tl-date-end", this.dateEndChoice);
          }
        }

        this.DateRangePicker = DateRangePicker;
        this.dateRangePickerProps = {
          defaultValue: [new Date(this.dateStartChoice), new Date(this.dateEndChoice)],
          onChange: (values) => this.updateDates(values)
        };

        if (this.isManagementViewType)
          this.Stats.getUsersChangelogs(this.dateStartChoice, this.dateEndChoice).then(
            (success) => {
              this.usersChangelogs = success.data;
              this.usersChangelogsLoaded = true;
            },
            (error) => {
              this.state = "error";
              this.error = error;
            }
          );
        else
          this.usersChangelogsLoaded = true;

        this.dateStart = moment(this.dateStartChoice);
        this.dateEnd = moment(this.dateEndChoice);
        this.isDateTodayOrLater = (moment().diff(this.dateStart, 'days') <= 0) || (moment().diff(this.dateEnd, 'days') <= 0);

        let usersWithEntries = this.isManagementViewType
          ? Object.values(success.data.teamsEntries).flat()
          : success.data.userWithEntries;
        usersWithEntries = usersWithEntries.filter(userWithEntries => this.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' ? userWithEntries.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' : true);
        this.usersWithEntries = usersWithEntries;

        this.summary = this.deserializeData(usersWithEntries);

        let onLongTermLeaveSortToEnd = [];

        this.summary.users.map(user => {

          let userData = user;
          userData.onLongTermLeave = false;

          if (user.worklogs.length === 0 & user.positionsDurationForLongTermLeave.length !== 0) {
            user.positionsDurationForLongTermLeave.map(position => {
              if (moment(position.positionFrom).diff(this.dateEnd) <= 0 && moment(position.positionTo).diff(this.dateEnd) >= 0) {
                userData.onLongTermLeave = true;
                onLongTermLeaveSortToEnd.push(user);
                return userData;
              }
            });
          }
          else if (user.positionsDurationForLongTermLeave.length !== 0) {
            let lastWorklogDate = user.worklogs[user.worklogs.length - 1].startedAtTime;
            user.positionsDurationForLongTermLeave.map((position) => {
              if (moment(position.positionFrom).diff(lastWorklogDate) <= 0 && moment(position.positionTo).diff(lastWorklogDate) >= 0) {
                userData.onLongTermLeave = true;
                onLongTermLeaveSortToEnd.push(user);
                return userData;
              }
            });
          }
        });
        this.summary.users = this.summary.users.filter(user => { return !user.onLongTermLeave; }).concat(onLongTermLeaveSortToEnd);
        this.cannotAcceptMyself = !this.user.acceptPersonalWorklogs && this.acceptanceHierarchyFlag && !success.data.canAcceptOwnEntries;

        if (!this.isManagementViewType)
          this.Stats.getOvertimes(this.dateStartChoice, this.dateEndChoice).catch((error) => { this.error = error; });
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.stateWorklog = "error";
        this.error = error;
      }
    );

    var timeout = this.$interval(() => {
      this.notes = this.Notes.getNotes();
    }, 10);
    this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
  }

  getMoreData(update) {
    this.isEditing = false;
    this.state = "loading";
    this.viewToggledOut = false;

    this.refreshWorklog(update);
  }

  updateDates(values) {
    this.disabledEdition = false;
    this.isAdding = false;

    this.dateStart = moment(values[0]);
    this.dateEnd = moment(values[1]);

    this.isDateTodayOrLater = (moment().diff(this.dateStart, 'days') <= 0) || (moment().diff(this.dateEnd, 'days') <= 0);
    this.viewToggledOut = moment.duration(this.dateEnd.diff(this.dateStart)).asDays() > 9;

    //save date to session storage
    if (this.isManagementViewType) {
      sessionStorage.setItem("roedl-mv-date-start", this.dateStartChoice);
      sessionStorage.setItem("roedl-mv-date-end", this.dateEndChoice);
    } else {
      sessionStorage.setItem("roedl-tl-date-start", this.dateStartChoice);
      sessionStorage.setItem("roedl-tl-date-end", this.dateEndChoice);
    }

    if (!this.viewToggledOut && !this.isInvalidDateStart && !this.isInvalidDateEnd) {
      this.getMoreData('update');
    }
  }

  toggleInactivityPeriods() {
    this.inactivityPeriods = !this.inactivityPeriods;
    this.Stats.changeTeamLeaderGlobalPreferences(
      this.isManagementViewType
        ? "mvWorklogInactivityPeriods"
        : "tlvWorklogInactivityPeriods"
      , this.inactivityPeriods
    ).then(() => {
      if (this.isManagementViewType)
        this.user.preferences.mvWorklogInactivityPeriods = this.inactivityPeriods;
      else
        this.user.preferences.tlvWorklogInactivityPeriods = this.inactivityPeriods;
    }).catch(
      res => this.Notes.postNote({
        type: "success",
        message: res.data
      })
    );
  }

  filterUsers() {
    this.filtersOpen = !this.filtersOpen;
    this.selectColumnsOpen = false;
    this.allUsersSelected = this.summary.users.every(u => u.visible);
  }

  selectAllUsers() {
    this.summary.users.forEach(u => u.visible = this.allUsersSelected);
    const data = this.summary.users.map( u => ({ name: u.name, id: u.id, visible: u.visible }));
    this.Stats.changeTeamLeaderGlobalPreferences(
      this.preferredUsers,
      data
    )
    .then(() => {
      this.isAdding = false;
      this.user.preferences[this.preferredUsers] = data;
    })
    .catch(
      res => this.Notes.postNote({
        type: "success",
        message: res.data
      })
    );
  }

  deselectUser() {
    if (this.allUsersSelected && this.summary.users.find(u => u.visible != true)) {
      this.allUsersSelected = false;
    }

    if (!this.allUsersSelected && this.summary.users.every(u => u.visible == true)) {
      this.allUsersSelected = true;
    }
    const data = this.summary.users.map( u => ({ name: u.name, id: u.id, visible: u.visible }) );
    this.Stats.changeTeamLeaderGlobalPreferences(
      this.preferredUsers,
      data
    ).then(() => {
      this.isAdding = false;
      this.user.preferences[this.preferredUsers] = data;
    }
    ).catch(
      res => this.Notes.postNote({
        type: "success",
        message: res.data
      })
    );
  }

  deselectColumns() {
    this.worklogsTableColumns.forEach(column => { this.checkColumnInvisibility(column.id); });
    this.Stats.changeTeamLeaderGlobalPreferences(
      this.preferredColumns,
      this.worklogsTableColumns
    ).then(
      () => {
        this.user.preferences[this.preferredColumns] = this.worklogsTableColumns;
      }
    ).catch(
      res => this.Notes.postNote({
        type: "success",
        message: res.data
      })
    );
    this.updateHeadersVisibility();
    this.allColumnsSelected = this.worklogsTableColumns.every(e=>e.visible);
  }

  checkColumnInvisibility(id) {
    const worklogsColumns = this.worklogsTableColumns || [];
    const doesColumnExist = worklogsColumns && worklogsColumns.find((c) => c.id == id);
    const isColumnHidden = doesColumnExist && worklogsColumns.find((c) => c.id == id).visible === false;
    return doesColumnExist ? isColumnHidden : false;
  }

  updateHeadersVisibility() {
    const headersToDisplay = [];
    const headersToMap = this.hasProjectsFlag ? this.headersToSelect : this.headersToSelect.filter(h => h.id !== "projectName");

    headersToMap.forEach(header => {
      const isHeaderInColumns = this.worklogsTableColumns.find(column => column.id == header.id);
      if (isHeaderInColumns) {
        this.worklogsTableColumns.find(column => column.id === header.id).visible && headersToDisplay.push(header);
      } else {
        headersToDisplay.push(header);
      }
      this.headers = headersToDisplay;
    });
  }

  exportData() {
    this.state = "loading";
    var users = this.summary.users.filter((x) => x.visible).map((x) => x.id);
    return this.Stats.export(
      this.dateStart.format("YYYY-MM-DD"),
      this.dateEnd.format("YYYY-MM-DD"),
      this.isManagementViewType ? "management" : "team",
      users,
      this.search.length > 0 ? this.search : null
    ).then((success) => {
      this.state = "loaded";
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers("content-type"),
        `klix-${this.dateStart.format("YYYY-MM-DD")}-${this.dateEnd.format("YYYY-MM-DD")}-${moment().format("HH:mm")}.xlsx`
      );
    }, (error) => {
      this.error = error;
      this.state = "error";
    });
  }

  deserializeData(usersWithEntries) {
    const filteredUsers = this.user.preferences[this.preferredUsers] || [];
    this.allUsersSelected = filteredUsers.every(u => u.visible);

    var users = usersWithEntries.map(userWithEntries => {
      const filteredUserVisibility = filteredUsers && filteredUsers.find(user => user.id == userWithEntries.user.id);
      var usersData = userWithEntries.entries
        .map((x) => {
          return this.deserializeWorklog(x);
        });

      let positionsDuration = [];
      let sortedPossitions = userWithEntries.positions.sort((a, b) => {
        return new Date(a.validFrom) - new Date(b.validFrom);
      });
      sortedPossitions.map((position, index, tab) => {
        if (index === tab.length - 1) {
          // last element
          if (tab.length > 1) { positionsDuration.push({ positionType: tab[index - 1].type, positionFrom: tab[index - 1].validFrom, positionTo: moment(position.validFrom).subtract(1, "days").format("YYYY-MM-DD") }); }
          positionsDuration.push({ positionType: position.type, positionFrom: position.validFrom, positionTo: moment().format("YYYY-MM-DD") });
        }
        else if (index === 0) { return; }
        else {
          positionsDuration.push({ positionType: tab[index - 1].type, positionFrom: tab[index - 1].validFrom, positionTo: moment(position.validFrom).subtract(1, "days").format("YYYY-MM-DD") });
        }
      });

      const positionsDurationForLongTermLeave = positionsDuration.filter(position => {
        return position.positionType === "LongTermLeave";
      });

      if (usersData[usersData.length - 1]) {
        usersData[usersData.length - 1].isLastOne = true;
      }
      // Block last process also, because it can go after last interrupt
      var worklogList = usersData.filter((x) => x.type == "process");
      if (worklogList[worklogList.length - 1]) {
        worklogList[worklogList.length - 1].isLastOne = true;
      }
      const durationSum = usersData.reduce((accum, curr) => curr.duration.clone().add(accum), moment.duration(0));

      usersData.map(worklog => {
        if (worklog.additionalInfo)
          worklog.clientNameWithAdditionalInfo = `(${worklog.additionalInfo}) ${worklog.clientName}`;
      });

      return {
        name: userWithEntries.user.fullName,
        id: userWithEntries.user.id,
        positionsDurationForLongTermLeave: positionsDurationForLongTermLeave,
        allAccepted: usersData.filter((x) => x.approved || x.archived).length == usersData.length,
        visible: filteredUsers && filteredUserVisibility ? filteredUserVisibility.visible : true,
        worklogs: usersData,
        isInCurrentTeam: userWithEntries.isInCurrentTeam,
        isBlocked: userWithEntries.user.blockedAt,
        durationSumText: this.$filter("hms")(durationSum.toJSON()),
        teamId: userWithEntries.user.teamId,
        invoicedTime: userWithEntries.user.invoicedTime
      };

    });
    users.sort((a, b) => a.name.localeCompare(b.name));
    var summary = {
      date: this.dateStart.format("YYYY-MM-DD") + " — " + this.dateEnd.format("YYYY-MM-DD"),
      users: users
    };
    return summary;
  }

  deserializeWorklog(x) {
    const selectedD365StatusFilters = this.d365StatusFilters.filter(status => status.selected).map(status => status.value);

    x.startedAtTime = moment.utc(
      moment.parseZone(
        x.startedAt,
        ["YYYY-MM-DDTHH:mm:ss.SSSZ", "YYYY-MM-DDTHH:mm:ssZ"]
      )
      .format("YYYY-MM-DDTHH:mm:ss.SSS")
    );
    x.finishedAtTime = moment.parseZone(x.finishedAt, ["YYYY-MM-DDTHH:mm:ss.SSSZ", "YYYY-MM-DDTHH:mm:ssZ"]);
    x.duration = moment.duration(x.duration);
    x.durationText = this.$filter("hms")(x.duration.toJSON());
    x.type = x.processName && "process" || "interrupt";
    x.isToday = x.startedAtTime.format("YYYY-MM-DD") == moment().format("YYYY-MM-DD");
    x.isFuture = x.startedAtTime.isAfter(moment(), 'day');
    x.projectId = x.projectId || x.project && x.project.id || null;
    x.projectName = x.projectName || x.project && x.project.name || null;
    x.projectSource = x.projectSource || x.project && x.project.source || null;
    x.visible = !x.d365WorklogProcessingStatus ? selectedD365StatusFilters.includes("noD365Status") : selectedD365StatusFilters.includes(x.d365WorklogProcessingStatus);
    x.invoicedTimeValue = x.invoicedTime && this.$filter("hms")(x.invoicedTime);
    return x;
  }

  refreshWorklog(update) {
    this.clientsLoaded = false;
    this.getWorkspaceInfo();

    var previousSummary = angular.copy(this.summary);

    const worklogsRequest =
      this.isManagementViewType
        ? this.Stats.getWorklogsForManager(this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD"))
        : this.Stats.getWorklogs(this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD"), update);

    worklogsRequest.then(
      (success) => {
        let usersWithEntries = this.isManagementViewType
          ? Object.values(success.data.teamsEntries).flat()
          : success.data.userWithEntries;

        usersWithEntries = usersWithEntries.filter(userWithEntries => this.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' ? userWithEntries.user.teamId !== '49a6dcff-c4e6-443e-9627-597070a68c8e' : true);

        this.usersWithEntries = usersWithEntries;
        this.summary = this.deserializeData(usersWithEntries);

        let onLongTermLeaveSortToEnd = [];

        this.summary.users.map(user => {

          let userData = user;
          userData.onLongTermLeave = false;

          if (user.worklogs.length === 0 & user.positionsDurationForLongTermLeave.length !== 0) {
            user.positionsDurationForLongTermLeave.map(position => {
              if (moment(position.positionFrom).diff(this.dateEnd) <= 0 && moment(position.positionTo).diff(this.dateEnd) >= 0) {
                userData.onLongTermLeave = true;
                onLongTermLeaveSortToEnd.push(user);
                return userData;
              }
            });
          }
          else if (user.positionsDurationForLongTermLeave.length !== 0) {
            let lastWorklogDate = user.worklogs[user.worklogs.length - 1].startedAtTime;
            user.positionsDurationForLongTermLeave.map((position) => {
              if (moment(position.positionFrom).diff(lastWorklogDate) <= 0 && moment(position.positionTo).diff(lastWorklogDate) >= 0) {
                userData.onLongTermLeave = true;
                onLongTermLeaveSortToEnd.push(user);
                return userData;
              }
            });
          }
        });

        this.summary.users = this.summary.users.filter(user => { return !user.onLongTermLeave; }).concat(onLongTermLeaveSortToEnd);

        if (previousSummary) {
          this.summary.users.map((user) => {
            previousSummary.users.map((previousVersionOfUser) => {
              if (previousVersionOfUser.id == user.id) {
                user.visible = previousVersionOfUser.visible; //hotfix
              }
            });
          });
        }

        if (!this.isManagementViewType)
          this.Stats.getOvertimes(this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD")).catch((error) => { this.error = error; });

        setTimeout(() => { this.state = "loaded"; }, 10);

        if (this.managementMode) {
          this.allUsersSelected = true;
          this.managementMode = false;
          this.selectAllUsers();
        }

      },
      (error) => {
        this.state = "error";
        this.stateWorklog = "error";
        this.error = error;
      }
    );
  }

  anyClientSelectorExists(worklog) {
    return Boolean(
      worklog.clientSelector ||
      worklog.serviceLineSelector ||
      !!worklog.projectSelector ||
      worklog.processSelector
    );
  }

  clearSickLeaveChange(worklog) {
    worklog.durationOverDaytime = false;
    if (worklog.process && worklog.process.globalName && ['sick leave', 'holiday leave'].includes(worklog.process.globalName.toLowerCase())) {
      worklog.durationText = '01:00:00';

      this.checkDurationOverDaytime(worklog);
    }
  }

  cancelSelectedValue(worklog, fieldName) {
    switch (fieldName) {
      case 'projects':
        worklog.project = undefined;
        worklog.selectedProjectId = undefined;
        worklog.projectSelector = worklog.client ? "clientProjects" : "interruptProjects";
        break;
      case 'process':
        this.clearSickLeaveChange(worklog);
        worklog.process = undefined;
        worklog.selectedProcessId = undefined;
        worklog.processSelector = true;
        worklog.outputs = null;
        worklog.outputType = null;
        break;
      case 'client':
        worklog.overtimeApplicationId = null;
        this.clearSickLeaveChange(worklog);
        this.clearKeywordsArrays();
        this.selectClientStart(worklog);
        delete worklog.billingTypeId;
        delete worklog.billingTypeName;
        this.billingTypeOptions = null;
        break;
      case 'serviceLine':
        worklog.serviceLine = undefined;
        worklog.serviceLineSelector = true;
        break;
      default:
        break;
    }
  }

  handleCreateOrEditWorklogStart(worklog, user) {
    if (!worklog)
      return this.newWorklog(user);
    else
      return this.editWorklogStart(worklog, user);
  }

  preCreateOrEditWorklogStart(user, worklog) {
    if (!worklog)
      this.isAdding = true;

    this.prepareWorkspace(user, worklog ? worklog.startedAt : moment(this.dateEnd).format('YYYY-MM-DDTHH:mm:ss.sssssssssZ') + `[${moment.tz.guess()}]`).then(
      () => {
        this.handleCreateOrEditWorklogStart(worklog, user);
      }
    );
  }

  editWorklogStart(worklog, user) {
    this.disabledEdition = false;
    worklog.previousVersion = angular.copy(worklog);
    worklog.previousVersion.volume = worklog.previousVersion.volume || null;
    worklog.edited = true;
    this.isEditing = true;
    worklog.oldDurationText = worklog.durationText;
    var newWorklog = {
      id: worklog.id,
      new: true,
      newDuration: worklog.duration,
      volume: worklog.volume,
      outputType: worklog.outputType,
      comment: worklog.comment,
      invoiceDetails: worklog.invoiceDetails,
      startDateChoice: worklog.startedAtTime.format("YYYY-MM-DD"),
      startTimeChoice: worklog.startedAtTime.format("HH:mm:ss"),
      startTimeMilliseconds: worklog.startedAtTime.format(".SSS"),
      durationText: this.$filter("hms")(worklog.duration.toJSON()),
      oldStartedAtTime: moment.utc(worklog.startedAtTime.format("YYYY-MM-DDTHH:mm:ss.SSS")),
      overtimeApplicationId: worklog.overtimeApplicationId,
      oldOvertimeApplicationId: worklog.overtimeApplicationId,
      billingTypeName: worklog.billingTypeName,
      billingTypeId: worklog.billingTypeId,
      clientMultiselectKeywords: worklog.clientMultiselectKeywords
    };

    if (worklog.billingTypeName) {
      newWorklog.billingTypeName = worklog.billingTypeName;
      newWorklog.billingTypeId = worklog.billingTypeId;
    }

    newWorklog.projectSource = this.setupWorklogSource(newWorklog.startDateChoice);

    const client = this.currentUserWorkspaceClients.filter(({ id }) => id == worklog.clientId)[0];
    const request = this.overtimeApplicationsFlag
      ? this.getPossibleApplicationsForUser(newWorklog, client, user)
      : Promise.resolve(newWorklog);
    const workspace = this.currentUserWorkspace || this.workspace;

    request.then((success) => {
      newWorklog = success;
      if (worklog.interruptCountryConfigurationId) {
        var interrupt = workspace.interrupts.filter(({ id }) => id == worklog.interruptCountryConfigurationId)[0];
        if (worklog.clientId) {
          this.selectInterruptType(newWorklog, interrupt, 'client');
        } else if (worklog.serviceLine) {
          newWorklog.selectedProjectId = worklog.projectId;
          newWorklog.edited = true;
          this.isEditing = true;
          this.selectInterruptType(newWorklog, interrupt, 'serviceLine');
        } else {
          newWorklog.selectedProjectId = worklog.projectId;
          this.selectInterruptType(newWorklog, interrupt, 'none');
        }
      }
      if (worklog.clientId) {
        this.selectClient(newWorklog, client, user, true, worklog.previousVersion);
      }
      if (worklog.processClientConfigurationId) {
        newWorklog.selectedProcessId = worklog.processClientConfigurationId;
        this.selectProcess(newWorklog, user, true);
      }
      if (worklog.projectId && worklog.clientId) {
        newWorklog.selectedProjectId = worklog.projectId;
        this.selectProject(newWorklog);
      }

      angular.extend(worklog, newWorklog);
      worklog.valueAdded = worklog.previousVersion.valueAdded;
      window.lastEditedWorklog = worklog;
    }).catch(() => {
      if (worklog.previousVersion) {
        angular.extend(worklog, worklog.previousVersion);
        delete worklog.previousVersion;
      }
      worklog.edited = false;
      this.isEditing = false;
      this.Notes.postNote({
        type: 'error',
        text: this.$translate.instant('WORK_DATA.EDIT_PROCESS_NOT_IN_WORKSPACE')
      });
    });
  }

  selectClientStart(worklog) {
    worklog.clientMultiselectKeywords = null;
    worklog.client = undefined;
    worklog.project = undefined;
    worklog.projectName = undefined;
    worklog.projectId = undefined;
    worklog.selectedProjectId = undefined;
    worklog.clientSelector = true;
    worklog.projectSelector = undefined;
    worklog.applications = null;
    worklog.overtimeApplicationId = null;
  }

  editWorklogSave(worklog, user) {
    this.disabledEdition = false;
    worklog.saving = true;
    this.updateDuration(worklog, user, true);
    this.updateStartTime(worklog, user, true);
    this.Stats.saveWorklog(worklog, this.isManagementViewType).then((response) => {
      const newSecondWorklog = response.data.entries.find(entry => entry.id === response.data.secondNewId);
      this.usersWithEntries = this.usersWithEntries.map(user => {
        if (user.user.id == worklog.userId && newSecondWorklog) {
          user.entries.push(newSecondWorklog);
        }

        user.entries = user.entries
          .map(entry => {
            response.data.entries.map(responseEntry => {
              if (entry.id === worklog.id)
                worklog.id = entry.id = response.data.newId;

              if (entry.id == responseEntry.id) {
                Object.keys(responseEntry).forEach(key => {
                  entry[key] = responseEntry[key];
                });

                if (worklog.id == responseEntry.id) {
                  if (!responseEntry.invoicedTime && entry.invoicedTime) {
                    delete worklog.invoicedTime;
                  }
                }

                if (worklog.id === responseEntry.id && !responseEntry.overtimeApplicationId) {
                  delete worklog.overtimeApplicationId;
                  delete worklog.overtimeApplicationCode;

                  if (worklog.interruptName && !responseEntry.clientId && entry.clientId) {
                    delete worklog.clientId;
                    delete worklog.clientName;
                    delete worklog.clientGroupName;
                    delete worklog.clientGroupId;
                  }
                }

              }

              entry.saving = false;
              entry.edited = false;
              this.isEditing = false;
              entry.new = false;
              entry.error = false;
            });

            return entry;
          })
          .sort((entryA, entryB) => {
            const startedAtA = entryA.startedAt.slice(0, 19);
            const startedAtB = entryB.startedAt.slice(0, 19);

            return moment(startedAtA).valueOf() - moment(startedAtB).valueOf();
          });

        return user;
      });
      this.summary = this.deserializeData(this.usersWithEntries);
      this.currentUserWorkspace = null;
      this.currentUserWorkspaceClients = null;
      this.clearKeywordsArrays();
      this.billingTypeOptions = null;
      delete worklog.previousVersion;
    }, (error) => {
      worklog.error = this.generateWorklogError(error.data);
      worklog.overlapError = error.data == "Processes overlap";
      worklog.saving = false;
      this.Notes.postNote({type: "error", error: error});
    });
  }

  editWorklogCancel(worklog, directly) {
    this.disabledEdition = false;
    angular.extend(worklog, worklog.previousVersion);
    worklog.comment = worklog.previousVersion.comment;
    worklog.invoiceDetails = worklog.previousVersion.invoiceDetails;
    delete worklog.process;
    worklog.edited = false;
    this.isEditing = false;
    worklog.durationInvalid = false;
    worklog.error = null;
    worklog.new = false;
    worklog.client = false;
    worklog.clientSelector = false;
    worklog.serviceLineSelector = false;
    worklog.projectSelector = null;
    worklog.processSelector = false;
    worklog.startTimeFormatInvalid = null;
    worklog.startTimeIsNotBeforeAllWorklogs = null;
    worklog.alreadyAllocated = null;
    worklog.billingTypeName = worklog.previousVersion.billingTypeName;
    worklog.billingTypeId = worklog.previousVersion.billingTypeId;
    delete worklog.previousVersion;
    this.billingTypeOptions = null;
    this.currentUserWorkspace = null;

    if (directly)
      this.currentUserWorkspaceClients = null;
  }

  debounce(func, timeout = 300){
    return (...args) => {
      clearTimeout(this.checkTimeOverlapTimer);
      this.checkTimeOverlapTimer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  generateWorklogError(error) {
    if (!error || !error.details)
      return error.message || this.$translate.instant("WORK_DATA.OVERLAP_ERROR");

    const errorDetails = error.details[0];
    if (!errorDetails)
      return error.message || this.$translate.instant("WORK_DATA.OVERLAP_ERROR");

    function formatDate(date) {
      return `${moment(date).format("YYYY-MM-DD")} ${date.slice(11).slice(0, 8)}`;
    }

    const errorEnding = `which started ${formatDate(errorDetails.startedAt.replace(/\[.*\]/g, ''))} and finished ${formatDate(errorDetails.finishedAt.replace(/\[.*\]/g, ''))}.`;

    switch (errorDetails.errorType) {
      case 'EntriesOverlapPartially':
      case 'ProcessesOverlapPartially':
        return `Entry overlap partially with ${errorDetails.processName ? 'worklog' : 'interrupt'} ${errorEnding}`;
      case 'EditedInterruptWouldContain':
        return `Edited interrupt would contain other entry ${errorEnding}`;
      case 'EntryIsContainedByOtherEntries':
        return `Entry is contained by other ${errorDetails.processName ? 'worklog' : 'interrupt'} ${errorEnding}`;
      default:
        return this.$translate.instant("WORK_DATA.OVERLAP_ERROR");
    }
  }

  checkTimeOverlap(worklog, user) {
    if (!worklog.newDuration)
      return;

    if (worklog.id) {
      this.Stats.saveWorklogValidation(worklog, this.isManagementViewType).then(
        () => worklog.alreadyAllocated = false,
        (error) => {
          if (error.data && error.data.message === 'Overtime application was allocated') {
            worklog.alreadyAllocated = true;
            worklog.error = null;
          }
          else
            worklog.error = this.generateWorklogError(error.data);
        }
      );
    } else {
      this.Stats.createWorklogValidations(worklog, user, this.isManagementViewType).then(
        () => worklog.error = null,
        (error) => worklog.error = this.generateWorklogError(error.data)
      );
     }
  }

  updateDuration(worklog, user, wihtoutCheckTimeOverlap) {
    worklog.durationOverDaytime = false;
    worklog.alreadyAllocated = false;
    var format = /\d+:\d\d:\d\d/;
    var match = worklog.durationText.match(format);
    const previousDuration = worklog.previousVersion && worklog.previousVersion.duration;
    const previousDurationMatch = worklog.previousVersion && worklog.previousVersion.durationText.match(format);
    const isPreviousDurationMatchSameAsNewMatch = match && previousDurationMatch && match[0] == previousDurationMatch[0];
    if (match && match.length == 1) {
      const newDuration = moment.duration(match[0]);
      // handle miliseconds precision when no duration change
      worklog.newDuration = isPreviousDurationMatchSameAsNewMatch && previousDuration || newDuration;
      worklog.durationInvalid = false;
    } else {
      worklog.newDuration = undefined;
      worklog.durationInvalid = true;
    }

    this.checkDurationOverDaytime(worklog);

    if (!wihtoutCheckTimeOverlap) {
      this.debounce(() => this.checkTimeOverlap(worklog, user))();
    }
  }

  updateStartTime(worklog, user, wihtoutCheckTimeOverlap) {
    this.initilizedWorklogForCurrentDay = false;
    worklog.durationOverDaytime = false;
    worklog.startTimeFormatInvalid = false;
    worklog.startTimeIsNotBeforeAllWorklogs = false;
    worklog.alreadyAllocated = false;
    worklog.startedAtTime = moment.utc(worklog.startDateChoice + "T" + worklog.startTimeChoice + (worklog.startTimeMilliseconds || ''));
    const format = /\d\d:\d\d:\d\d/;
    const match = worklog.startTimeChoice.match(format);

    if (!match) {
      worklog.startTimeFormatInvalid = true;
      return;
    }

    if (this.isDateTodayOrLater && !worklog.id) {
      const addedWorklogs = user.worklogs.filter(w => w.id);
      const newWorklogStartTimeIsBeforeAllWorklogs = addedWorklogs.every(w => w.startedAtTime.isAfter(worklog.startedAtTime));
      if (!newWorklogStartTimeIsBeforeAllWorklogs) {
        worklog.startTimeIsNotBeforeAllWorklogs = true;
        return;
      }
    }

    this.checkDurationOverDaytime(worklog);

    if (!wihtoutCheckTimeOverlap) {
      this.debounce(() => this.checkTimeOverlap(worklog, user))();
    }
  }

  postNoteForWorklogResponse(text) {
    this.Notes.postNote({
      type: text.includes(this.$translate.instant("WORK_DATA.D365_STATUS.AFTER_ACCEPT_SENT_SUCCESS")) ? "success" : "warning",
      text
    });
  }

  acceptWorklog(worklog, acceptAll) {
    worklog.saving = true;
    return this.Stats.acceptWorklog(worklog, this.isManagementViewType).then((success) => {
      worklog.saving = false;
      worklog.edited = false;
      this.isEditing = false;
      worklog.approved = true;
      worklog.wasEdited = false;
      delete worklog.previousVersion;
      if (success.data.d365WorklogProcessingStatus !== undefined) {
        worklog.d365WorklogProcessingStatus = success.data.d365WorklogProcessingStatus;
        let noteText;

        if (success.data.d365WorklogProcessingStatus === "SendingError")
          noteText = this.$translate.instant("WORK_DATA.D365_STATUS.AFTER_ACCEPT_SENT_FAIL");
        else if (success.data.d365WorklogProcessingStatus === 'D365Error')
          noteText = this.$translate.instant("WORK_DATA.D365_STATUS.AFTER_ACCEPT_SENT_SUCCESS_BUT_PROCESS_ERROR");
        else if (['D365ProcessMatchingNotFound', 'D365ProjectNotFound'].includes(success.data.d365WorklogProcessingStatus))
          noteText = this.$translate.instant("WORK_DATA.D365_STATUS.AFTER_ACCEPT_SENT_FAIL_NO_MATCHING");
        else
          noteText = this.$translate.instant("WORK_DATA.D365_STATUS.AFTER_ACCEPT_SENT_SUCCESS");

        if (!acceptAll) {
          this.postNoteForWorklogResponse(noteText);
          const user = this.summary.users.find(({ id }) => id === worklog.userId);
          user.allAccepted = user.worklogs.filter((x) => x.approved || x.archived).length == user.worklogs.length;
        }
        else return Promise.resolve(noteText);
      }
    }, (res) => {
      if (res.status !== 403)
        worklog.error = this.generateWorklogError(res.data);
      else
        this.Notes.postNote({
          type: "error",
          error: res
        });
    });
  }

  declineWorklog(worklog) {
    this.modalConfig = {
      text: "WORK_DATA.DELETE_CONFIRMATION",
      cancelText: "CANCEL",
      acceptText: "DELETE"
    };
    this.bModal.show(this.modalConfig).then(() => {
      worklog.saving = true;
      this.Stats.declineWorklog(worklog, this.isManagementViewType).then((response) => {
        this.usersWithEntries = this.usersWithEntries.map(userWithEntries => {
          userWithEntries.entries = userWithEntries.entries
            .filter(entry => entry.id != worklog.id)
            .map(entry => {
              const updatedEntry = response.data.find(responseEntry => responseEntry.id === entry.id);
              if (updatedEntry)
                Object.keys(updatedEntry).forEach((key) => {
                  entry[key] = updatedEntry[key];
                });

              return entry;
            })
            .sort((entryA, entryB) => {
              const startedAtA = entryA.startedAt.slice(0, 19);
              const startedAtB = entryB.startedAt.slice(0, 19);

              return moment(startedAtA).valueOf() - moment(startedAtB).valueOf();
            });
          return userWithEntries;
        });
        this.summary = this.deserializeData(this.usersWithEntries);
      }, (err) => {
        if (err.data && err.data.message) {
          let errorMessage = "";
          if (err.data.message.includes('cannot be deleted due to settled application'))
            errorMessage = 'Worklog is already settled';
          else if (err.data.message.includes('cannot be deleted due to allocated application'))
            errorMessage = 'Worklog is already allocated';
          else
            errorMessage = err.data.message;

          worklog.saving = false;
          this.Notes.postNote({
            type: "error",
            error: {
              errorMessage
            }
          });
        } else
          worklog.error = this.generateWorklogError(err.data);
      });
    }, angular.noop);
  }

  acceptAllWorklogs(user) {
    Promise.allSettled(user.worklogs
      .filter((x) => !x.approved && !x.archived && !x.saving && x.id)
      .map((x) => {
        return this.acceptWorklog(x, true);
      }))
      .then((responses) => {
        const noteStatuesCounter = responses.map((res) => res.value).reduce((acc, noteStatus) => {
          acc[noteStatus] = (acc[noteStatus] || 0) + 1;
          return acc;
        }, {});

        Object.entries(noteStatuesCounter).forEach(([key, value]) => {
          this.postNoteForWorklogResponse(`(${value}x) ${key}`);
        });
      });
    user.allAccepted = true;
  }

  setupWorklogSource(newWorklogStartDateChoice) {
    if (!this.projectFlagHistory) return null;

    const formattedProjectFlagHistory = this.projectFlagHistory.map(el => {
      return {
        start: el.start && moment(el.start).format("YYYY-MM-DD"),
        end: el.end ? moment(el.end).format("YYYY-MM-DD") : moment().add(1, 'days').format("YYYY-MM-DD"), // if no endDate set in future
        flag: el.flag,
        source: el.source
      };
    });

    const flagsThatDay = formattedProjectFlagHistory.filter(el => {
      return moment(el.start).isSameOrBefore(moment(newWorklogStartDateChoice)) && moment(el.end).isSameOrAfter(moment(newWorklogStartDateChoice));
    });

    const lastFlagHistoryThatDay = flagsThatDay.length ? flagsThatDay[flagsThatDay.length - 1] : null;
    const lastFlagThatDay = lastFlagHistoryThatDay.flag;

    if (lastFlagThatDay == manuallyProjectsFlag) return manuallyProjectsSource;
    if (lastFlagThatDay == erpProjectsFlag) return lastFlagHistoryThatDay.source;
    if (lastFlagThatDay == "NoProjectFlag") return null;
  }

  /* CREATION FORM */

  prepareWorkspace(user, startDate) {
    this.state = "loading";
    return this.$q.all([this.Stats.getUserWorkspace(user.id, startDate)]).then(
      (success) => {
        this.addOutputs(user.id);
        this.currentUserWorkspace = success[0].data;
        this.currentUserWorkspaceClients = this.currentUserWorkspace.clients.map(client => {
          if (client.additionalInfo)
            client.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.name}`;

          return client;
        });
        this.state = "loaded";
      },
      (res) => {
        this.state = "error";
        this.Notes.postNote({
          type: "error",
          error: res
        });
        return this.$q.reject(res);
      }
    );
  }

  newWorklog(user) {
    var worklogs = angular.copy(user.worklogs).sort((x, y) => x.finishedAtTime.diff(y.finishedAtTime));
    var lastWorklogOpt = worklogs[worklogs.length - 1];

    /*
      We are extracting the data from the LOCAL time provided by backend sooo...
      it's based on strings, because moment doesn't like local times.
    */
    // Choosing a date
    var startDateChoice = (lastWorklogOpt && lastWorklogOpt.finishedAtTime || angular.copy(this.dateEnd).add(8, "hours")).format("YYYY-MM-DD");

    // Choosing hour :-0
    var startTimeChoice = null;

    if (this.isDateTodayOrLater) {
      startTimeChoice = "";
      this.initilizedWorklogForCurrentDay = true;
    } else if (lastWorklogOpt && lastWorklogOpt.finishedAtTime) {
      var localLastFinishedAtTime = lastWorklogOpt.finishedAtTime._i.slice(11).slice(0, 8);
      startTimeChoice = moment.duration(localLastFinishedAtTime).add(1, "second").format("HH:mm:ss");
    } else {
      startTimeChoice = "08:00:00";
    }

    var newWorklog = {
      durationOverDaytime: false,
      new: true,
      newDuration: moment.duration(),
      comment: "",
      invoiceDetails: null,
      addedManually: true,
      volume: 0,
      startDateChoice: startDateChoice,
      startTimeChoice: startTimeChoice == "24:00:00" ? "00:00:00" : startTimeChoice,
      startedAtTime: moment.utc(startDateChoice + "T" + startTimeChoice),
      durationText: "01:00:00"
    };

    newWorklog.projectSource = this.setupWorklogSource(newWorklog.startDateChoice);

    user.worklogs.push(newWorklog);

    this.checkDurationOverDaytime(newWorklog);
    this.summary.users.forEach(summaryUser => this.clearAllEditiedWorklogs(summaryUser));
    this.disabledEdition = true;
  }

  checkDurationOverDaytime(worklog) {
    const dt = moment.duration(worklog.durationText);
    const duration = angular.copy(dt);

    const startedAtTimeDate = worklog.startedAtTime && angular.copy(worklog.startedAtTime).format("YYYY-MM-DD");
    const sumStartAndDurationDate = worklog.startedAtTime && angular.copy(worklog.startedAtTime).add(duration && duration.as('s'), "s").format("YYYY-MM-DD");

    if (startedAtTimeDate != sumStartAndDurationDate || startedAtTimeDate != worklog.startDateChoice) {
      worklog.durationOverDaytime = true;
    }
  }

  clearAllEditiedWorklogs({ worklogs }) {
    worklogs.forEach(worklog => {
      if (worklog.edited) {
        this.editWorklogCancel(worklog);
      }
    });
  }

  removeNew(user, worklog) {
    this.disabledEdition = false;
    this.currentUserWorkspace = null;
    this.currentUserWorkspaceClients = null;
    user.worklogs.splice(user.worklogs.indexOf(worklog), 1);
    this.isAdding = false;
    if (user.worklogs.length == 0) {
      angular.copy(this.dateEnd).subtract(8, "hours").subtract(1, "second");
    }
    this.clearKeywordsArrays();
    this.billingTypeOptions = null;
  }

  addNewInterrupt(worklog) {
    worklog.type = 'interrupt';
  }

  addNewProcess(worklog) {
    worklog.type = 'process';
    worklog.clientSelector = true;
  }

  hasSelectedClientNoProjects(worklog) {
    return Boolean(
      worklog.client.projectsToSelect &&
      worklog.client.projectsToSelect.length <= 0 &&
      !worklog.project
    );
  }

  shouldProcessBeSelected(worklog) {
    return Boolean(
      worklog.new &&
      worklog.client &&
      worklog.type == 'process' &&
      !worklog.process
    );
  }

  filterProjectsToSelect(clientProjects, worklogDate, worklogSource) {
    return clientProjects
      .filter(project => project.source == worklogSource)
      .filter(p => !(p.status === "Archived" && moment(worklogDate).isAfter(moment(p.validUntil))));
  }

  getPossibleApplicationsForUser(worklog, client, user) {
    worklog.hasOvertimeApplicationInfo = false;
    worklog.applications = [];

    if (!client)
      return Promise.resolve(worklog);

    return this.OvertimeApplications.getPossibleApplicationsForUser(user.id, client.id, worklog.startDateChoice, worklog.id && worklog.overtimeApplicationId).then(
      (success) => {
        const applications = success.data;
        worklog.hasOvertimeApplicationInfo = true;
        const applicationIsFullySettled = worklog.overtimeApplicationId && !applications.some(application => application.id === worklog.overtimeApplicationId);

        if (applicationIsFullySettled) {
          worklog.applicationIsFullySettled = true;
          return worklog;
        }

        worklog.applications = applications.filter(application => (
          application.clients.includes(client.id)
          && (
            application.id === worklog.oldOvertimeApplicationId
              ? true
              : application.duration !== application.reportedDuration
          )
        ));

        return worklog;
      },
      (res) => {
        this.Notes.postNote({
          type: "error",
          error: res
        });
      }
    );
  }

  selectClient(worklog, client, user, alreadyHasApplications, previousVersion) {
    if (this.overtimeApplicationsFlag && !alreadyHasApplications)
      this.getPossibleApplicationsForUser(worklog, client, user);
    else
      worklog.hasOvertimeApplicationInfo = true;

    var processGroupLookup = {};
    const workspace = this.currentUserWorkspace || this.workspace;
    workspace.processGroups.map((pg) => { processGroupLookup[pg.id] = pg; });
    var processesLookup = {};
    workspace.processes.map((p) => { processesLookup[p.id] = p; });

    var pccs = workspace.processClientConfigurations
      .filter(({ processId }) => processesLookup[processId] != undefined)
      .filter(({ clientId }) => clientId == client.id)
      .map((pcc) => {
        pcc.processName = processesLookup[pcc.processId].name;
        pcc.processGroupName = processGroupLookup[processesLookup[pcc.processId].processGroupId].name;
        pcc.isHidden = processesLookup[pcc.processId].isHidden;

        const globalName = processesLookup[pcc.processId].globalName;
        if (globalName) {
          pcc.globalName = globalName;
        }

        return pcc;
      });
    client.processes = pccs;
    worklog.client = client;
    if (worklog.serviceLine) worklog.serviceLine = null;
    if (worklog.process) {
      var newProcessSearch = client.processes.filter(({ processName }) => processName == worklog.process.processName);
      var newProcess = newProcessSearch[0] || undefined;
      worklog.process = newProcess;
      worklog.valueAdded = newProcess && newProcess.valueAdded;
    } else {
      delete worklog.process;
      delete worklog.valueAdded;
    }

    if (worklog.projectSource) {
      client.projectsToSelect = this.filterProjectsToSelect(client.projects, worklog.startDateChoice, worklog.projectSource);
      worklog.client = client;
      if (client.projectsToSelect.length > 0) worklog.projectSelector = "clientProjects";
    } else {
      client.projectsToSelect = [];
      worklog.client = client;
    }

    //set processSelector for no projectSource || new worklog when client has no projects || edited worklog when no process and client has projects
    worklog.processSelector = (!worklog.projectSource && !(worklog.process || worklog.interrupt)) ||
      (worklog.type == "process" && !worklog.process && this.hasSelectedClientNoProjects(worklog)) ||
      (worklog.type == "process" && !worklog.process && worklog.edited && !this.hasSelectedClientNoProjects(worklog));

    worklog.clientSelector = false;

    if (!worklog.interrupt || (worklog.interrupt && previousVersion && previousVersion.valueAdded)) {
      if (previousVersion && worklog.client.defaultBillingTypeId) {
        this.billingTypeOptions = cloneDeep(this.billingTypes);
        if (worklog.billingTypeId && !this.billingTypes.some(billingType => billingType.id === worklog.billingTypeId))
          this.billingTypeOptions.push({id: worklog.billingTypeId, name: worklog.billingTypeName});
      }
      if (!previousVersion && client.defaultBillingTypeId) {
        worklog.billingTypeId = client.defaultBillingTypeId;
        worklog.billingTypeName = client.defaultBillingTypeName;

        if (client.defaultBillingTypeId)
          this.billingTypeOptions = cloneDeep(this.billingTypes);
      }
    }

    if (worklog.client.multiselectKeywords && worklog.client.multiselectKeywords.length > 0) {
      const selectedKeywords = worklog.clientMultiselectKeywords && worklog.clientMultiselectKeywords.map(keyword => ({id: keyword, name: keyword})) || [];

      this.multiselectKeywords = new Array(
        ...worklog.client.multiselectKeywords.map(keyword => ({id: keyword, name: keyword})),
        ...selectedKeywords.filter(selectedKeyword => !worklog.client.multiselectKeywords.includes(selectedKeyword.id))
      );

      this.selectedKeywords = this.multiselectKeywords.filter(keyword => selectedKeywords.map(selectedKeyword => selectedKeyword.id).includes(keyword.id));
    } else
      this.clearKeywordsArrays();
  }

  changeServiceLine(worklog) {
    worklog.serviceLineSelector = false;
  }

  selectProcess(worklog, user, edition) {
    worklog.process = worklog.client.processes.filter(({ id }) => id == worklog.selectedProcessId)[0];
    if (!worklog.process) {
      throw new Error(`Process configuration ${worklog.selectedProcessId} not available in workspace`);
    }
    worklog.valueAdded = worklog.process && worklog.process.valueAdded;
    worklog.processSelector = false;
    const workspace = this.currentUserWorkspace || this.workspace;

    if (this.outputTypeFeatureFlag && worklog.process.hasVolume) {
      if (workspace.outputChoices && workspace.outputChoices[worklog.selectedProcessId]) {
        worklog.outputs = workspace.outputChoices[worklog.selectedProcessId].map(output => output.outputType);
        if(!worklog.outputType) { worklog.outputType = worklog.outputs[0]; }
      }
      else {
        const processInWorkspace = workspace.processes.find(process => process.id == worklog.process.processId);
        if (processInWorkspace.outputs && processInWorkspace.outputs.length) {
          worklog.outputs = processInWorkspace.outputs;
          if (worklog.outputType && !worklog.outputs.includes(worklog.outputType))
            worklog.outputs.unshift(worklog.outputType);

          if (!worklog.outputType)
            worklog.outputType = worklog.outputs[0];
        }
      }
    }

    const userWithEntries = this.usersWithEntries.find(userWithEntries => userWithEntries.user.id === user.id);
    const userHasWorknorm =
      userWithEntries
      && userWithEntries.positions
      && userWithEntries.positions.length > 0
      && userWithEntries.positions.some(position => position.type === 'Worknorm');

    if (!edition && worklog.process.globalName && ['sick leave', 'holiday leave'].includes(worklog.process.globalName.toLowerCase()) && userHasWorknorm) {
      const momentDayOfWeek = moment(worklog.startDateChoice).day();
      const dayOfWeek = momentDayOfWeek === 0 ? 6 : momentDayOfWeek - 1;
      const worknormAsMinutes = userWithEntries.positions.find(position => position.type === 'Worknorm').worknorms[dayOfWeek] * 60;
      const hour = Math.floor(worknormAsMinutes / 60);
      const minutes = worknormAsMinutes % 60;
      worklog.durationText = `${hour < 10 ? '0' + hour : hour}:${minutes < 10 ? '0' + minutes : minutes}:00`;

      this.checkDurationOverDaytime(worklog);
    }
  }

  selectInterruptType(worklog, interrupt, type) {
    worklog.interrupt = interrupt;
    worklog.selectedInterruptType = type;

    if (type == 'client') {
      worklog.clientSelector = true;
      worklog.serviceLineSelector = false;
    } else if (type == 'serviceLine') {
      // new worklog no serviceLine
      if (!worklog.edited && !worklog.serviceLine) worklog.serviceLineSelector = true;

      // handle change from client interrupt to serviceLine interrupt
      if (worklog.edited && !worklog.serviceLine && worklog.wasEdited && !worklog.clientSelector) worklog.serviceLineSelector = true;

      worklog.interruptProjects = this.setupInterruptProjects(worklog);
    } else if (type == 'none') {
      worklog.serviceLineSelector = false;
      worklog.interruptProjects = this.setupInterruptProjects(worklog);
    }
  }

  setupInterruptProjects(worklog) {
    let interruptProjects = [];
    if (worklog.projectSource) {
      const internalClient = this.currentUserWorkspaceClients && this.currentUserWorkspaceClients.find(cl => cl.name == "Internal");
      interruptProjects = internalClient ?
        this.filterProjectsToSelect(internalClient.projects, worklog.startDateChoice, worklog.projectSource) : [];

      if (!worklog.project && !worklog.selectedProjectId && interruptProjects.length > 0) {
        worklog.projectSelector = "interruptProjects";
      }
    }
    return interruptProjects;
  }

  showWideClientProjectSelector(worklog) {
    return Boolean(
      worklog.client &&
      worklog.projectSource &&
      !worklog.project &&
      worklog.type == 'process' &&
      !worklog.process &&
      !worklog.edited &&
      !worklog.processSelector
    );
  }

  isClientProjectSelector(worklog) {
    return Boolean(
      worklog.new &&
      !worklog.project &&
      worklog.client &&
      worklog.type
    );
  }

  isNoneOrSlProjectSelector(worklog) {
    return Boolean(
      worklog.new &&
      !worklog.project &&
      worklog.interrupt &&
      worklog.selectedInterruptType !== 'client' &&
      worklog.projectSelector == 'interruptProjects'
    );
  }

  selectProject(worklog) {
    if (worklog.type == 'interrupt' && (worklog.selectedInterruptType == 'none' || worklog.selectedInterruptType == 'serviceLine')) {
      worklog.project = worklog.interruptProjects && worklog.interruptProjects.filter(({ id }) => id == worklog.selectedProjectId)[0];
      worklog.projectName = worklog.interruptProjects && worklog.project.name;
      worklog.projectId = worklog.interruptProjects && worklog.project.id;
    } else {
      const projectSelected = worklog.client.projects && worklog.client.projects.filter(({ id }) => id == worklog.selectedProjectId)[0];
      worklog.project = projectSelected;
      worklog.projectName = projectSelected && projectSelected.name;
      worklog.projectId = projectSelected && projectSelected.id;

      // set processSelector when adding new worklog for client with project
      if (worklog.type == "process" && !worklog.process && !worklog.edited && worklog.selectedProjectId && worklog.project) worklog.processSelector = true;
    }
    worklog.projectSelector = undefined;
  }

  preCreateOrEditWorklog(worklog, user) {
    if (this.selectedKeywords)
      worklog.clientMultiselectKeywords = this.selectedKeywords.map(keyword => keyword.id);

    if (!worklog.overtimeApplicationId) {
      if (worklog.splitOvertimeApplicationWorklog === false)
        delete worklog.splitOvertimeApplicationWorklog;

      if (!worklog.id)
        return this.createWorklog(worklog, user);
      else
        return this.editWorklogSave(worklog, user);
    }

    const application = worklog.applications.find(application => application.id === worklog.overtimeApplicationId);
    let splitIsNeeded;

    if (application) {
      const leftDuration = moment.duration(application.duration)
        .subtract(moment.duration(application.reportedDuration))
        .add(worklog.oldOvertimeApplicationId === application.id ? moment.duration(worklog.oldDurationText) : 0);
      const durationChange = (!worklog.oldDurationText || worklog.oldDurationText === worklog.durationText)
        ? moment.duration(worklog.durationText)
        : moment.duration(worklog.oldDurationText).subtract(moment.duration(worklog.durationText));
      splitIsNeeded = moment.duration(leftDuration).subtract(durationChange).asMilliseconds() < 0;
    }

    if (splitIsNeeded) {
      this.splitModal = true;
      this.splitModalData = {
        worklog: worklog,
        user: user
      };
    } else {
      worklog.splitOvertimeApplicationWorklog = false;

      if (!worklog.id)
        return this.createWorklog(worklog, user);
      else
        return this.editWorklogSave(worklog, user);
    }
  }

  createOrEditWorklogWithSplit() {
    const worklog = angular.copy(this.splitModalData.worklog);
    const user = angular.copy(this.splitModalData.user);

    worklog.splitOvertimeApplicationWorklog = true;

    this.splitModalData = null;
    this.splitModal = null;

    if (!worklog.id)
      return this.createWorklog(worklog, user);
    else
      return this.editWorklogSave(worklog, user);
  }

  createWorklog(worklog, user) {
    this.disabledEdition = false;
    worklog.saving = true;
    this.updateDuration(worklog, user, true);
    this.updateStartTime(worklog, user, true);
    this.Stats.createWorklog(worklog, user, this.isManagementViewType).then((response) => {
      this.isAdding = false;
      worklog.saving = false;
      worklog.edited = false;
      this.isEditing = false;
      worklog.new = false;
      worklog.error = null;
      let newSecondWorklog;

      if (response.data) {
        const newWorklog = response.data.entries.find(entry => entry.id === response.data.newId);
        newSecondWorklog = response.data.entries.find(entry => entry.id === response.data.secondNewId);

        if (newWorklog)
          Object.keys(newWorklog).forEach((key) => {
            worklog[key] = newWorklog[key];
          });

        if (worklog.client && worklog.client.additionalInfo) {
          newWorklog.additionalInfo = worklog.client.additionalInfo;
        }
      }
      this.usersWithEntries = this.usersWithEntries.map((userWithWorklogs) => {
        if (userWithWorklogs.user.id == worklog.userId) {
          userWithWorklogs.entries.push(worklog);

          if (newSecondWorklog) {
            if (worklog.client && worklog.client.additionalInfo)
              newSecondWorklog.additionalInfo = worklog.client.additionalInfo;
            userWithWorklogs.entries.push(newSecondWorklog);
          }
        }

        userWithWorklogs.entries = userWithWorklogs.entries
          .map(entry => {
            const updatedEntry = response.data.entries.find(responseEntry => responseEntry.id === entry.id);
            if (updatedEntry)
              Object.keys(updatedEntry).forEach((key) => {
                entry[key] = updatedEntry[key];
              });

            return entry;
          })
          .sort((entryA, entryB) => {
            const startedAtA = entryA.startedAt.slice(0, 19);
            const startedAtB = entryB.startedAt.slice(0, 19);

            return moment(startedAtA).valueOf() - moment(startedAtB).valueOf();
          });
        return userWithWorklogs;
      });
      this.summary = this.deserializeData(this.usersWithEntries);
      this.currentUserWorkspace = null;
      this.currentUserWorkspaceClients = null;
      this.billingTypeOptions = null;
      this.clearKeywordsArrays();
    }, (error) => {
      if (error.data && error.data.message === 'Cannot rearrange vacations to insert worklog')
        this.Notes.postNote({
          type: "error",
          error: error
        });

      worklog.error = this.generateWorklogError(error.data);
      worklog.saving = false;
    });
  }

  checkRed(distance) {
    if (distance) return moment.duration(distance) >= moment.duration(30, 'minutes');
    return false;
  }

  checkOrange(distance) {
    if (distance) return moment.duration(distance) >= moment.duration(5, 'minutes') && moment.duration(distance) < moment.duration(30, 'minutes');
    return false;
  }

  checkYellow(distance) {
    if (distance) return moment.duration(distance) >= moment.duration(1, 'minutes') && moment.duration(distance) < moment.duration(5, 'minutes');
    return false;
  }


  handleSortStates(prevState, stateToSort, user) {
    if (!prevState) return stateToSort[user.id] = "true";
    if (prevState == "true") return stateToSort[user.id] = "reverse";
    if (prevState == "reverse") return stateToSort[user.id] = undefined;
  }

  worklogTableSortStateChange(user, column) {
    let prevState;
    if (column == 'clientName') {
      this.sortStatesProject = {};
      this.sortStatesProcessGroup = {};
      this.sortStatesProcess = {};
      prevState = this.sortStates[user.id];
      this.handleSortStates(prevState, this.sortStates, user);
    }
    if (column == 'projectName') {
      this.sortStates = {};
      this.sortStatesProcessGroup = {};
      this.sortStatesProcess = {};
      prevState = this.sortStatesProject[user.id];
      this.handleSortStates(prevState, this.sortStatesProject, user);
    }
    if (column == 'processGroupCountryConfigurationName') {
      this.sortStates = {};
      this.sortStatesProject = {};
      this.sortStatesProcess = {};
      prevState = this.sortStatesProcessGroup[user.id];
      this.handleSortStates(prevState, this.sortStatesProcessGroup, user);
    }
    if (column == 'processName') {
      this.sortStates = {};
      this.sortStatesProject = {};
      this.sortStatesProcessGroup = {};
      prevState = this.sortStatesProcess[user.id];
      this.handleSortStates(prevState, this.sortStatesProcess, user);
    }
  }

  cancelWorklog(worklog) {
    if (worklog.type === 'interrupt' && worklog.client)
      this.clearKeywordsArrays();
    worklog.interrupt = undefined;
    worklog.client = undefined;
    worklog.interruptName = undefined;
    worklog.project = undefined;
    worklog.projectId = undefined;
    worklog.projectName = undefined;
    worklog.selectedProjectId = undefined;
    worklog.selectedInterruptType = undefined;
    worklog.interruptProjects = undefined;
    worklog.clientSelector = false;
    worklog.projectSelector = undefined;
    this.billingTypeOptions = null;
    worklog.billingTypeId = null;
    worklog.billingTypeName = null;
  }

  addOutputsToWorklog(worklog, workspace) {
    let processInWorkspace = undefined;
    if (worklog.process) {
      processInWorkspace = workspace.processes.find(process => process.id == worklog.process.processId);
    }
    if (!this.outputTypeFeatureFlag && processInWorkspace && processInWorkspace.outputs && processInWorkspace.outputs.length) {
      worklog.outputs = processInWorkspace.outputs;
      if (worklog.outputType && !worklog.outputs.includes(worklog.outputType))
        worklog.outputs.unshift(worklog.outputType);
    }
    return worklog;
  }

  addOutputs(userId) {
    const workspace = this.currentUserWorkspace || this.workspace;
    if (
      this.summary &&
      this.summary.users &&
      this.summary.users.length > 0 &&
      workspace &&
      workspace.processes &&
      workspace.processes.length > 0
    )
      userId
        ? this.summary.users.find(user => user.id === userId).worklogs.map(worklog => this.addOutputsToWorklog(worklog, workspace))
        : this.summary.users = this.summary.users.map(user => {
          user.worklogs = user.worklogs.map(worklog => this.addOutputsToWorklog(worklog, workspace));
          return user;
        });
  }

  filterWorklogs(search) {
    if (!search || search.length === 0) return true;
    var self = this;
    return function(worklog) {
      const searchValue = search.toLowerCase();
      return (
        (
          worklog.clientName && worklog.clientName.toLowerCase().includes(searchValue) ||
          worklog.serviceLine && worklog.serviceLine.toLowerCase().includes(searchValue) ||
          worklog.type == 'interrupt' && self.$translate.instant('INTERRUPTION').toLowerCase().includes(searchValue)
        ) ||
        worklog.projectName && worklog.projectName.toLowerCase().includes(searchValue) ||
        (
          worklog.process && worklog.process.processGroupName && worklog.process.processGroupName.toLowerCase().includes(searchValue) ||
          !worklog.processSelector && !worklog.process && worklog.processGroupCountryConfigurationName && worklog.processGroupCountryConfigurationName.toLowerCase().includes(searchValue) ||
          worklog.type == 'interrupt' && self.$translate.instant('INTERRUPTION').toLowerCase().includes(searchValue)
        ) ||
        (
          !worklog.processSelector && worklog.processName && worklog.processName.toLowerCase().includes(searchValue) ||
          worklog.process && worklog.process.processName && worklog.process.processName.toLowerCase().includes(searchValue) ||
          (!worklog.interrupt || !worklog.interrupt.name) && worklog.interruptName && worklog.interruptName.toLowerCase().includes(searchValue) ||
          worklog.interrupt && worklog.interrupt.name && worklog.interrupt.name.toLowerCase().includes(searchValue)
        )
      );
    };
  }

  showData() {
    this.state = "loading";

    const data = {
      viewLevels: []
    };

    Object.keys(this.preferencesDictionary).forEach(key => {
      if (this[key])
        data.viewLevels.push(this.preferencesDictionary[key]);
    });

    if (this.employeeLevel) {
      data.teamId = this.employeeLevelTeam;
    }

    this.Work.editViewLevelSettings(data).then(
      (success) => {
        this.setPreferencesInfo(success.data);

        if (this.noViewLevelSettings) {
          this.managementMode = false;
          this.noViewLevelSettings = false;
          this.init();
        } else {
          this.isEditing = false;
          this.refreshWorklog();
        }
      },
      (res) => {
        this.Notes.postNote({
          type: "error",
          error: res
        });
      }
    );
  }

  displayMultiselectKeywords(clientMultiselectKeywords) {
    return clientMultiselectKeywords.join(', ');
  }

  clearKeywordsArrays() {
    this.multiselectKeywords = null;
    this.selectedKeywords = null;
  }

  valueAddedChangeHandler(worklog) {
    if (worklog.type === 'interrupt' && worklog.client.defaultBillingTypeId && worklog.valueAdded) {
      this.billingTypeOptions = cloneDeep(this.billingTypes);
    }

    if (worklog.type === 'interrupt' && (!worklog.client.defaultBillingTypeId || !worklog.valueAdded)) {
      this.billingTypeOptions = null;
    }
  }

  displaySelectedKeywordsInTitle(selectedKeywords) {
    return this.displayMultiselectKeywords(selectedKeywords.map(keyword => keyword.name));
  }

  extrasForName(subTeam) {
    const extraValues = [];
    if (subTeam.excludeFromProfitabilityReport)
      extraValues.push(`${this.$translate.instant("WORK_DATA.DISPLAY_PREFERENCES.EXCLUDED_FROM_PROFITABILITY_VIEW")}`);

    if (subTeam.archivedAt)
      extraValues.push(`(${this.$translate.instant("TEAMS.ARCHIVED")})`);

    return extraValues.join(" ");
  }

  d365WorklogStatusToText(status) {
    if (status === 'D365Sent')
      return this.$translate.instant("WORK_DATA.D365_STATUS.SENT");
    else if (status === 'D365Processed')
      return this.$translate.instant("WORK_DATA.D365_STATUS.PROCESSED");
    else
      return this.$translate.instant("WORK_DATA.D365_STATUS.PROCESSED_TO_KCP");
  }

  synchronizeD365Statuses() {
    this.state = "loading";

    const worklogParentConnection = this.summary.users.reduce((acc, user) => {
      user.worklogs.filter(worklog => worklog.d365WorklogProcessingStatus).forEach(worklog => acc[worklog.id] = user.id);
      return acc;
    }, {});
    const worklogsIds = Object.keys(worklogParentConnection);

    this.Stats.synchronizeWorklogsStatuses(worklogsIds).then(
      (success) => {
        success.data.forEach(worklogStatus => {
          const user = this.summary.users.find(user => user.id === worklogParentConnection[worklogStatus.id]);
          user.worklogs.find(worklog => worklog.id === worklogStatus.id).d365WorklogProcessingStatus = worklogStatus.status;
        });
        this.state = "loaded";
      },
      (res) => {
        this.state = "error";
        this.Notes.postNote({
          type: "error",
          error: res
        });
      }
    );
  }

  resendWorklogToD365(worklog, userId) {
    this.state = "loading";

    this.Stats.resendWorklogToD365(worklog.id).then(
      (success) => {
        const user = this.summary.users.find(user => user.id === userId);
        user.worklogs.find(worklog => worklog.id === success.data.id).d365WorklogProcessingStatus = success.data.status;
        this.state = "loaded";
      },
      (res) => {
        this.state = "error";
        this.Notes.postNote({
          type: "error",
          error: res
        });
      }
    );
  }

  setWorklogsVisibility() {
    const selectedD365StatusFilters = this.d365StatusFilters.filter(status => status.selected).map(status => status.value);
    this.summary.users
      .forEach(user => user.worklogs
        .forEach(worklog =>
          worklog.visible = !worklog.d365WorklogProcessingStatus ? selectedD365StatusFilters.includes("noD365Status") : selectedD365StatusFilters.includes(worklog.d365WorklogProcessingStatus)
        )
      );
  }

  triggerAllD365Statuses() {
    this.d365StatusFilters.forEach(filter => filter.selected = this.allD365StatusesSelected);
    this.setWorklogsVisibility();
  }

  changeD365StatusFilter(value) {
    if (this.d365StatusFilters.every(status => status.selected))
      this.allD365StatusesSelected = true;
    else
      this.allD365StatusesSelected = false;

    this.d365StatusFilters.forEach(status => {
      if (status.value === value)
        status.selected = !status.selected;
    });
    this.setWorklogsVisibility();
  }

  formatNumberToTime(hours) {
    const formattedHours = hours.replaceAll(',', '.');
    const duration = moment.duration(formattedHours, 'hours');

    const timePart = (timePart) => {
      return timePart < 10 ? `0${timePart}` : timePart;
    };

    return `${timePart(duration.get('hours'))}:${timePart(duration.get('minutes'))}:${timePart(duration.get('seconds'))}`;
  }

   validateInvoicingTimeWithUpdate(worklog) {
    const hour = worklog.invoicedTimeValue;

    if (worklog.invoicedTimeError)
      delete worklog.invoicedTimeError;

    if ((!hour || hour.length === 0))
      return;

    clearTimeout(this.updateHoursFunction);
    this.updateHoursFunction = setTimeout(() => {

      const numberFormat = /^(\d*([,.]\d*)|\d*)$/;
      const format = /^(\d+:[0-5]\d:[0-5]\d|\d*([,.]\d*)|\d*)$/;
      const match = hour.match(format);

      if (!match) {
        worklog.invoicedTimeError = this.$translate.instant("INVALID_TIME_FORMAT");
      }
      else {
        if (worklog.invoicedTimeError)
          delete worklog.invoicedTimeError;

        if (hour.match(numberFormat)) {
          worklog.invoicedTimeValue = this.formatNumberToTime(hour);
        }
      }
    }, 700);
  }
}
